interface Package {
  id: string | number;
  name: string;
  width: number;
  length: number;
  height: number;
  count: number;
  weight: number;
  unit: string;
  unitsPerCount: string;
  price: number;
}

function sumPackagesPrice(packages: Package[]) {
  let price = 0;
  for (let i = 0; i < packages.length; i += 1) price += packages[i].price;
  return price;
}

export default function useDelivery() {
  const english = [
    'PENDING_ORDER_CONFIRMATION',
    'ORDER_CONFIRMATION',
    'PENDING',
    // CommonDeliveryStatusSelectorStatus will map on here
    'ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER',
    // 'CANCEL',
    'PREPARE_TO_DELIVER',
    'ON_THE_WAY',
    'NOT_SUCCESS',
    'SOME_SUCCESS',
    'SUCCESS',
    'HUB',
    // To here ^
    'PURCHASE',
    'REVISE',
    // 'HAS_INVOICE',
  ];

  const thai = [
    // TODO: ลบสถานะ 'รอการยืนยันการสั่งสินค้า', 'ยืนยันรายการสินค้า', ออก และเพิ่มสถานะ รอรับเข้าระบบ / ไม่รับเข้าระบบ
    'รอการยืนยันการสั่งสินค้า',
    'ยืนยันรายการสินค้า',
    'รอการยืนยันรับส่งสินค้า',
    // CommonDeliveryStatusSelectorStatus will map on here
    'รับรายการจัดส่ง',
    // 'ยกเลิกรายการ',
    'เตรียมส่ง',
    'กำลังจัดส่งสินค้า',
    'ส่งไม่สำเร็จ',
    'ส่งสำเร็จบางรายการ',
    'ส่งสินค้าสำเร็จ',
    'ถึงศูนย์กระจายสินค้า',
    // To here ^
    'เริ่มทำรายการ / ซื้อสินค้า',
    'ส่งใหม่',
    // 'วางบิลแล้ว',
  ];

  const translate = (status: string) => thai[english.indexOf(status)];

  const shipmentStatusClassMap = (status: string) => {
    switch (status) {
      case 'ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-yellow-500';
      case 'CANCEL':
        return 'block text-gray-600 rounded-xl text-xs py-1 text-center bg-gray-300';
      case 'PREPARE_TO_DELIVER':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-purple-500';
      case 'ON_THE_WAY':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-indigo-400';
      case 'SUCCESS':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-500';
      case 'NOT_SUCCESS':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-500';
      case 'SOME_SUCCESS':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-orange-500';
      case 'ORDER_RECEIVE':
        return 'block text-yellow-900 rounded-xl text-xs py-1 text-center bg-green-500';
      case 'REVISE':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-400';
      case 'HUB':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-300';
      default: return '';
    }
  };

  const mapStatusToTracking = (status: string): number => {
    switch (status) {
      case 'PENDING_ORDER_CONFIRMATION':
      case 'ORDER_CONFIRMATION':
      case 'PENDING':
      case 'ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER':
        return 1;
      case 'PREPARE_TO_DELIVER':
      case 'NOT_SUCCESS':
      case 'SOME_SUCCESS':
        return 2;
      case 'ON_THE_WAY':
        return 3;
      case 'ORDER_RECEIVE':
      case 'WAITING_PAYMENT':
      case 'SUCCESS':
      case 'DONE':
        return 4;
      default:
        return 0;
    }
  };

  return {
    sumPackagesPrice,
    english,
    thai,
    translate,
    shipmentStatusClassMap,
    mapStatusToTracking,
  };
}
